module.exports = __webpack_public_path__ + "static/media/iPhone-X-Mockup.5e37c37a.png";


//////////////////
// WEBPACK FOOTER
// ./src/image/roi/iPhone-X-Mockup.png
// module id = 3311
// module chunks = 0